// import React from 'react';

export default function Service() {
  return (
    <main className="Home-body">
      <h2>Service</h2>
      
    </main>
  );
}